import React, { useState } from 'react';
import { useCollaborationContext } from './CollaborationProvider';

export const CollaborationStatus = () => {
  const { isConnected, activeUsers } = useCollaborationContext();
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div 
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        zIndex: 1000,
        transition: 'all 0.3s ease'
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Version compacte (par défaut) */}
      {!isHovered && (
        <div style={{
          width: '40px',
          height: '40px',
          borderRadius: '50%',
          backgroundColor: isConnected ? '#28a745' : '#dc3545',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
          fontSize: '12px',
          fontWeight: 'bold',
          cursor: 'pointer',
          boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
          transition: 'all 0.3s ease'
        }}>
          {activeUsers.length}
        </div>
      )}

      {/* Version étendue (au survol) */}
      {isHovered && (
        <div style={{
          background: 'white',
          border: '1px solid #dee2e6',
          borderRadius: '8px',
          padding: '12px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          minWidth: '180px',
          transform: 'translateY(-10px)',
          transition: 'all 0.3s ease'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: '8px'
          }}>
            <div style={{
              width: '8px',
              height: '8px',
              borderRadius: '50%',
              backgroundColor: isConnected ? '#28a745' : '#dc3545',
              marginRight: '8px'
            }}></div>
            <span style={{ fontSize: '13px', fontWeight: 'bold' }}>
              {isConnected ? 'Connecté' : 'Déconnecté'}
            </span>
          </div>
          
          <div style={{ fontSize: '12px', color: '#6c757d', marginBottom: '6px' }}>
            {activeUsers.length} utilisateur{activeUsers.length !== 1 ? 's' : ''} en ligne
          </div>
          
          {activeUsers.length > 0 && (
            <div>
              {activeUsers.slice(0, 3).map((user, index) => (
                <div key={`user-${user.socketId || user.userId}-${index}`} style={{
                  fontSize: '11px',
                  color: '#495057',
                  padding: '1px 0'
                }}>
                  👤 {user.userName}
                </div>
              ))}
              {activeUsers.length > 3 && (
                <div style={{ fontSize: '11px', color: '#6c757d' }}>
                  +{activeUsers.length - 3} autre{activeUsers.length - 3 !== 1 ? 's' : ''}
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};